import { useMemo } from "react"

import { getYear } from "date-fns"

import { useTranslation } from "@l2r-front/l2r-i18n"

import { appRoad } from "../../../../common/constants/appRoad"
import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { RoadworksYearlyBudgetKpiComponent } from "../../components/RoadworksYearlyBudgetKpi"
import { STATUS_DONE, STATUS_TODO } from "../../constants/status"
import { useRoadworksProject } from "../../hooks/queries/useRoadworksProjectQuery"
import { useRoadworksQuartersStats } from "../../hooks/queries/useRoadworksQuartersStats"

import * as Styled from "./RoadworksYearlyBudgetKpi.styled"

export function RoadworksYearlyBudgetKpi(props) {

    const { data: project, isError: isErrorProject, isLoading: isLoadingProject } = useRoadworksProject()
    const { data, isError: isErrorStats, isLoading: isLoadingStats } = useRoadworksQuartersStats()

    const isError = isErrorStats || isErrorProject
    const isLoading = isLoadingStats || isLoadingProject

    const { t } = useTranslation()
    const currentYear = getYear(new Date())

    const costs = useMemo(() => {
        if (!data?.cost?.[currentYear]) {
            return {
                [STATUS_TODO]: "0.00",
                [STATUS_DONE]: [
                    "0.00",
                    "0.00",
                    "0.00",
                    "0.00",
                ],
            }
        } else {
            return data.cost[currentYear]
        }
    }, [data, currentYear])

    const totalDoneCost = useMemo(() => {
        return costs?.[STATUS_DONE].reduce((acc, numberFromApi) => {
            return acc + parseFloat(numberFromApi)
        }, 0) || 0
    }, [costs])

    const budget = useMemo(() => {
        return project?.budgets?.[currentYear]
    }, [currentYear, project])

    if (isError) {
        return <Styled.KpiError
            {...props}
            title={t(I18N_NAMESPACE, "containers.notationKpi.error")}
            id="roadworks-budget-kpi-error"
            message={t(I18N_NAMESPACE, "containers.roadworksYearlyBudgetKpi.error")}
            path={`${appRoad.path}/${appRoad.modules.roadworks.path}`}
        />
    }

    if (isLoading) {
        return <Styled.KpiSkeleton {...props} />
    }

    return <Styled.KpiCard
        {...props}
        id="roadworks-quarters-kpi"
        path={`${appRoad.path}/${appRoad.modules.roadworks.path}`}
    >
        <Styled.Title variant="H1">
            {t(I18N_NAMESPACE, "containers.roadworksYearlyBudgetKpi.title", {
                year: currentYear,
            })}
        </Styled.Title>
        <Styled.ChartContainer>
            {data ? <RoadworksYearlyBudgetKpiComponent
                budget={budget}
                currency={project?.currency?.symbol}
                quartersCost={costs}
                totalDoneCost={totalDoneCost}
            />
                : <div>{t(I18N_NAMESPACE, "containers.roadworksYearlyBudgetKpi.noData")}</div>}
        </Styled.ChartContainer>
    </Styled.KpiCard>
}